export * from "@knitto-ui/tailwind";
export { plugin as default } from "@knitto-ui/tailwind";
